import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("nxcms:deliveryTypeModuleSelected", function (e, data) {
    if (!data.module) {
      return;
    }

    function selectedCallback(point) {
      const dataEl = $('input[data-delivery-type-module="' + data.module + '"]');
      const detailEl = dataEl.parents(".paymentgroup").find(".delivery-module-detail");

      if (!point) {
        dataEl.attr("data-delivery-type-module-data", null);
        detailEl.text("");
        $('#selectDeliveryType input[type="radio"]').first().trigger("change");
        return;
      }

      dataEl.attr(
        "data-delivery-type-module-data",
        `${point.id}^^^${point.name} (${point.street} ${point.city})`,
      );
      detailEl.text(`${point.name} (${point.street} ${point.city})`);
      $('#selectDeliveryType input[type="radio"]').first().trigger("change");

      // Close the modal after selection
      const modal = $("#balikobot-pickup-modal");
      window.NXCMS.modal(modal, false);
      modal.remove();
    }

    const d = data.module.split(":");
    if (d[0] == "balikobot") {
      if (d.length < 2) {
        return;
      }
      // if - is not in the second part, then it is not a pickup point
      if (d[1].indexOf("-") < 0 || d[1].indexOf("@") < 0) {
        return;
      }

      const mode = d[1].split("-")[1].split("@")[0];
      if (mode != "pickup") {
        return;
      }

      const deliveryTypeId = data.deliveryTypeId;
      const existingModal = document.getElementById("balikobot-pickup-modal");
      if (existingModal) {
        window.NXCMS.modal($("#balikobot-pickup-modal"), false);
        existingModal.remove();
      }

      const bbmodal = $(`
        <div id="balikobot-pickup-modal" class="modal" tabindex="-1">
          <bb-pickup-point-selector delivery-type-id="${deliveryTypeId}"></bb-pickup-point-selector>
        </div>`);
      $("body").append(bbmodal);

      // Set up the callback for pickup point confirmation
      const selectorElement = bbmodal.find("bb-pickup-point-selector")[0];
      if (selectorElement) {
        selectorElement.onPickupPointConfirmed = selectedCallback;
      }

      window.NXCMS.modal($("#balikobot-pickup-modal"), true);
    }
  });
});
